import { render } from "./ButtonRedSecondary.vue?vue&type=template&id=5d175495"
import script from "./ButtonRedSecondary.vue?vue&type=script&lang=js"
export * from "./ButtonRedSecondary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__